<template>
	<div class="col" align-x="center" gutter="35">
		<div class="col" align-x="center" gutter="5">
			<h1>註冊個人帳號</h1>
			<span>註冊者須滿18歲</span>
		</div>
		<el-form :model="ruleForm" :rules="rules" ref="registerForm" status-icon>
			<el-form-item prop="email">
				<el-input v-model="ruleForm.email" placeholder="請輸入電子信箱"></el-input>
			</el-form-item>
			<el-form-item prop="password">
				<el-input v-model="ruleForm.password" type="password" placeholder="請輸入密碼（至少8字元）"></el-input>
			</el-form-item>
			<el-form-item prop="passwordConfirm">
				<el-input v-model="ruleForm.passwordConfirm" type="password" placeholder="再次輸入密碼"></el-input>
			</el-form-item>
			<el-form-item>
				<el-row type="flex" justify="end">
					<a href="#" class="color-text3" @click="dialogVisible=true">會員服務條款</a>
				</el-row>
			</el-form-item>
			<el-form-item>
				<div class="button-tp normal-button register-btn color-text2 bg-black-gray3" @click="register">註冊</div>
			</el-form-item>
			<el-form-item>
				<p class="center color-danger">{{errorMessage}}</p>
			</el-form-item>
		</el-form>
		<terms-dialog :visible.sync="dialogVisible"></terms-dialog>
		<el-dialog :visible.sync="visibleSuccess" width="30%" @close="$router.push({name: 'Login'})">
			<div class="description layout-row layout-hv-center">註冊成功，請到信箱收取驗證信</div>
			<div slot="footer" class="dialog-footer layout-row layout-hv-center">
				<div class="success-button button-tp color-white bg-green1" @click="$router.push({name: 'Login'})">確定</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import TermsDialog from "@/components/register/TermsDialog.vue";
import { mapActions } from "vuex";

export default {
	components: { TermsDialog },
	data() {
		return {
			errorMessage: "",
			dialogVisible: false,
			visibleSuccess: false,
			ruleForm: {},
			rules: {
				email: [
					{ required: true, message: "請輸入電子信箱", trigger: "blur" },
					{ type: "email", message: "請輸入正確信箱格式", trigger: "blur" }
				],
				password: [
					{
						required: true,
						message: "請輸入密碼（至少8字元）",
						trigger: "blur"
					},
					{ min: 8, message: "長度至少為8字元", trigger: "blur" }
				],
				passwordConfirm: [
					{ required: true, message: "再次輸入密碼", trigger: "blur" },
					{ validator: this.checkPassword, trigger: "blur" }
				]
			}
		};
	},
	methods: {
		...mapActions(["logout"]),
		...mapActions("user", ["signUp"]),
		checkPassword(rule, value, callback) {
			if (this.ruleForm.password != value) {
				callback(new Error("兩次密碼不相同"));
			}
			callback();
		},
		register() {
			this.$refs["registerForm"].validate(async valid => {
				if (valid) {
					let data = {
						account: this.ruleForm.email,
						password: this.ruleForm.password
					};
					try {
						let res = await this.signUp(data);
						this.visibleSuccess = true;
					} catch (e) {
						this.errorMessage = e.message;
					}
				} else {
					this.errorMessage = "輸入資料不正確";
					return false;
				}
			});
		}
	},
	created() { }
};
</script>

<style lang="scss" scoped>
.el-form {
	width: 360px;
}
.el-input {
	width: 100%;
}
.el-button {
	width: 100%;
}
p.center {
	text-align: center;
}
.success-button {
	width: 150px;
	height: 30px;
}

.register-btn {
	width: 360px;
	height: 40px;
	border: solid 1px #cacfd4;
}
</style>
